import React, {memo, useState} from "react";
import PropTypes from "prop-types";
import {Checkbox, ListItemButton} from "@mui/material";
import SessionItemMenu from "./SessionItemMenu";
import SessionItemText from "./SessionItemText";

const SessionListItem = ({
  session,
  isSelected,
  hasBadge,
  isEditing,
  isHovered,
  className,
  onLoad,
  onHover,
  onLeave,
  onRenameComplete,
  onStartRename,
  onDelete,
  onShare,
  messages,
  onTogglePin,
  onLeaveSession,
  selectMode,
  isChecked,
  onToggleSelect,
}) => {
  const [hasFocus, setHasFocus] = useState(false);

  return (
    <span
      onMouseEnter={() => onHover(session.sessionId)}
      onMouseLeave={onLeave}
      onFocus={() => setHasFocus(true)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setHasFocus(false);
        }
      }}
    >
      <ListItemButton
        selected={!selectMode && isSelected}
        onClick={selectMode ? () => onToggleSelect(session.sessionId) : onLoad}
        data-session-id={session.sessionId}
        className={className}
        disableRipple
      >
        {selectMode && (
          <Checkbox
            size="small"
            checked={isChecked}
            onClick={(e) => e.stopPropagation()}
            onChange={() => onToggleSelect(session.sessionId)}
          />
        )}
        <SessionItemText
          session={session}
          hasBadge={hasBadge}
          isEditing={isEditing}
          onRenameComplete={onRenameComplete}
        />
        {!selectMode && !isEditing && (
          <SessionItemMenu
            session={session}
            messages={messages}
            isCurrentSession={isSelected}
            onRename={onStartRename}
            onDelete={onDelete}
            onShare={onShare}
            onTogglePin={onTogglePin}
            onLeaveSession={onLeaveSession}
            isVisible={isHovered || hasFocus}
          />
        )}
      </ListItemButton>
    </span>
  );
};

SessionListItem.propTypes = {
  session: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  hasBadge: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isHovered: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onLoad: PropTypes.func,
  onHover: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  onRenameComplete: PropTypes.func.isRequired,
  onStartRename: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired,
  onTogglePin: PropTypes.func.isRequired,
  onLeaveSession: PropTypes.func.isRequired,
  selectMode: PropTypes.bool,
  isChecked: PropTypes.bool,
  onToggleSelect: PropTypes.func,
};

export default memo(SessionListItem);
